import React, { useEffect, useRef,useState } from 'react';
import * as d3 from 'd3';
import styles from './LineChart.module.css';

const margin = { top: 5, right: 10, bottom: 5, left: 10 };

const LineChart = ({ chartData, round=1, xAxisLabel=null, yAxisLabel=null, color }) => {
  const chartRef = useRef(null);
  const [chartWidth,setChartWidth]=useState(0);
  const [chartHeight,setChartHeight]=useState(0);

  const [chartLoading,setChartLoading] = useState(true);
  // const [valueTip,setValueTip]=useState({
  //   x:0,
  //   y:0,
  //   value:0,
  //   opacity:0
  // });

  const maxRange=100;

  useEffect(()=>{
      const resizeObserver=new ResizeObserver((entries)=>{
        for(let entry of entries){
          if(entry.target && document.body.contains(entry.target)){
            const {width,height}=chartRef.current.getBoundingClientRect();
            setChartWidth(width);
            setChartHeight(height);
            // setBoundsWidth(width - MARGIN.right - MARGIN.left)
            // setBoundsHeight(height - MARGIN.top - MARGIN.bottom)
          }
        }
      })

      if(chartRef.current){
        resizeObserver.observe(chartRef.current)
      }

      return()=>{
        if(chartRef.current){
          resizeObserver.unobserve(chartRef.current);
        }
        resizeObserver.disconnect();
      }
  },[])

  useEffect(() => {
    if (chartData) {

      const data=(()=>{
          if(chartData.length>maxRange){
            const sample=[];
            const step=Math.floor((chartData.length-2)/(maxRange-2))
            sample.push(chartData[0]);
            for (let i=step;i<chartData.length-step;i+=step){
              sample.push(chartData[i]);
            }
            sample.push(chartData[chartData.length-1]);
            return sample;
          }
          else return chartData;
      })();

      if(data.length==0) return;

      const innerWidth = chartWidth - margin.left - margin.right;
      const innerHeight = chartHeight - margin.top - margin.bottom;
      
      const xScale = d3
        .scaleLinear()
        .domain([d3.min(data, (d) => d.x), d3.max(data, (d) => d.x)])
        .range([0, innerWidth]);

      let yDomain;
      let yTicks;

      if(data.length==1){
        yDomain=[d3.min(data, (d) => d.y)-0.1, d3.max(data, (d) => d.y)+0.1];
        yTicks=4;
      }
      else if(data.length>1){
        yDomain=[d3.min(data, (d) => d.y), d3.max(data, (d) => d.y)];
        yTicks=data.length;
      }
      
      const yScale = d3
        .scaleLinear()
        .domain(yDomain)
        .nice(data.length)
        .range([innerHeight, 0]);

      const area = d3
        .area()
        .x((d) => xScale(d.x))
        .y0(innerHeight)
        .y1((d) => yScale(d.y))
        .curve(d3.curveCatmullRom)
        .defined((d) => !isNaN(d.y))

      const svg = d3.select(chartRef.current);
      svg.selectAll('*').remove();
      svg.attr('width', '90%').attr('height', '100%');
      // svg.attr('width', chartWidth).attr('height', chartHeight);

      const xAxis = d3
        .axisBottom(xScale)
        .ticks(4)
        .tickFormat(d3.format('d'))
        .tickPadding(14)
        .tickValues(data.map((d) => d.x))
        .tickSize(-innerHeight)

      const yAxis = d3
        .axisLeft(yScale)
        .ticks(yTicks)
        .tickPadding(20)
        .tickSize(-innerWidth)

      const chartGroup = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

      chartGroup
        .append('g')
        .attr('class', styles['line-chart-axis'] + ' ' + styles['line-chart-xAxis'])
        .attr('transform', `translate(0,${innerHeight})`)
        .call(xAxis);

      // chartGroup
      //   .append('g')
      //   .attr('class', styles['line-chart-axis'] + ' ' + styles['line-chart-YAxis'])
      //   .call(yAxis);

      // chartGroup
      //   .append('text')
      //   .attr('class', styles['line-chart-axis-label'] + ' ' + styles['line-chart-xAxis-label'])
      //   .attr('transform', `translate(${innerWidth / 2},${chartHeight - margin.bottom + 15})`)
      //   .text(xAxisLabel?.toLowerCase());

      // chartGroup
      //   .append('text')
      //   .attr('class', styles['line-chart-title'])
      //   .attr('transform', `translate(${innerWidth / 2},${innerHeight + 50})`)
      //   .style('text-anchor', 'middle')
      //   .text(yAxisLabel);

      // chartGroup
      //   .append('text')
      //   .attr('class', styles['line-chart-axis-label'] + ' ' + styles['line-chart-yAxis-label'])
      //   .attr('transform', `translate(-40,${innerHeight / 2}) rotate(-90)`)
      //   .text(yAxisLabel?.toLowerCase());

      const defs = svg.append('defs');
      const gradientId = `areaGradient_${Math.random().toString(36).substr(2, 9)}`;
      const gradient = defs
        .append('linearGradient')
        .attr('id', gradientId)
        .attr('x1', '0%')
        .attr('y1', '0%')
        .attr('x2', '0%')
        .attr('y2', '100%');
      gradient
        .append('stop')
        .attr('offset', '0%')
        .attr('stop-color', color)
        .attr('stop-opacity', 0.7);
      gradient
        .append('stop')
        .attr('offset', '100%')
        .attr('stop-color', 'white')
        .attr('stop-opacity', 0);

      // chartGroup
      //   .append('path')
      //   .datum(data)
      //   .attr('class', styles['line-chart-area'])
      //   .attr('d', area)
      //   .style('fill', `url(#${gradientId})`); 

      const line = d3
        .line()
        .x((d) => xScale(d.x))
        .y((d) => yScale(d.y))
        .curve(d3.curveCatmullRom)
        .defined((d) => !isNaN(d.y)) 

      chartGroup
        .append('path')
        .datum(data)
        .attr('class', styles['line-chart-path'])
        .attr('d', line)
        .style('stroke-width','2.2px')
        .style('stroke', color)
        .attr('stroke-dasharray',1000)
        .attr('stroke-dashoffset',1000)
        .transition()
        .duration(1500)
        .ease(d3.easeLinear)
        .attr('stroke-dashoffset',0)

      chartGroup
        .selectAll('.dot')
        .data([round])
        .enter()
        .append('circle')
        .attr('class', 'dot')
        .style('fill',color)
        .style('stroke','white')
        .style('stroke-width','3px')
        .attr('cx', i => xScale(data[i-1].x))
        .attr('cy', i => yScale(data[i-1].y))
        .attr('r', 0)
        .transition()
        .duration(250)
        .ease(d3.easeLinear)
        .attr('r',5)
      //   .on('mouseover', (e, d) => {
      //     const [x,y]=d3.pointer(chartRef.current);
      //     // setValueTip(()=>({
      //     //   x:e.x-chartRef.current.getBoundingClientRect().left-25,
      //     //   y:e.y-chartRef.current.getBoundingClientRect().top-25,
      //     //   value:d.y,
      //     //   opacity:1
      //     // }))
      // })
      // .on('mouseout', () => {
      //     // setValueTip((prevData)=>({
      //     //   ...prevData,
      //     //   opacity:0
      //     // }))
      // });
      setChartLoading(false);
    }
  }, [chartData]);

  // useEffect(()=>{
  //   // const isDraw=chartRef.current.querySelector('')
  // },[chartRef])

  return (
    <>
    {/* { !chartLoading ? */}
    <div className={`${styles['line-chart']} ${chartLoading&&styles['chart-loading']}`}>
      <svg 
      ref={chartRef}
      width='90%'
      height='100%'
      ></svg>
      {/* <div
      className={styles['value-tip']}
      style={{'opacity':valueTip.opacity,'left':valueTip.x+'px','top':valueTip.y+'px'}}>
      {valueTip.value}
      </div> */}
    </div>
    {/* :
    <div className={styles['chart-loading']}
    style={{width:width+'px',height:height+'px'}}>
    </div>
    } */}
    </>
  )
};

export default LineChart;